import * as React from 'react';
import classnames from 'classnames';
import style from './TypeLabel.scss';
import { Caption } from '../../../PageElements/Caption';

// TODO: refactor the types in the flat tree
export const LABEL_TYPES = {
  OPERATION: 'FUNCTION',
  PROPERTY: 'PROPERTY',
  SECTION: 'API',
  CATEGORY: 'API',
  MAIN_ENTITY: 'OBJECT',
  WEBHOOK: 'WEBHOOK',
  EVENT: 'EVENT',
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE',
  PATCH: 'PATCH',
  HEAD: 'HEAD',
  OPTIONS: 'OPTIONS',
  MD: 'ARTICLE',
  DEPRECATED: 'DEPRECATED',
  TAG: 'API',
};

interface TypeLabelProps {
  type: string;
  withBorder?: boolean;
  dataHook?: string;
  className?: string;
}

export const TypeLabel = ({
  type,
  withBorder = true,
  dataHook,
  className = '',
}: TypeLabelProps) => {
  const classNames = classnames(style.label, style[type.toLowerCase()], {
    [style.noBorder]: !withBorder,
  });

  return (
    <Caption
      className={`${classNames} ${className}`}
      dataHook={`type-label${dataHook ? `-${dataHook}` : ''}`}
    >
      {LABEL_TYPES[type]}
    </Caption>
  );
};

TypeLabel.displayName = 'TypeLabel';
